import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANG } from '../../Constants/constants';
import { useEffect, useState } from 'react';
import ReactImageGallery from 'react-image-gallery';
// import { Button } from '../Button/Button'
import clock from '../../assets/images/icn-clock.svg';
import calendar from '../../assets/images/icn-calendar.svg';
import bath from '../../assets/images/icn-bath.svg';
import bed from '../../assets/images/icn-bad.svg';
import roomSize from '../../assets/images/icn-room_size.svg';
import location from '../../assets/images/icn-location.svg';
import imageIcon from '../../assets/images/photo-icon.png';
import { scheduledToursResponse } from '../LandingPage/Tours/UpcomingTours';
import imagePlaceholder from '../../assets/images/community-image-1.jpg';
import { useSelector } from 'react-redux'

interface TourCardProps {
  children?: any;
  tour: scheduledToursResponse;
}

const TourCard = ({ children, tour }: TourCardProps) => {
  const { t, i18n } = useTranslation();
  const displayLocale = i18n.language === SUPPORTED_LANG.ES ? 'es-US' : 'en-US';
  // const { address_1 } = tour
  const [images, setImages] = useState<any>([]);

  const builderName = localStorage.getItem('builder_name');

  useEffect(() => {
    if (tour?.images?.length > 0) {
      const result = tour.images.map((original: string) => {
        const imageUrl = builderName?.toLowerCase().includes('kbhome')
        ? original
        : `//images.weserv.nl?url=${encodeURIComponent(original)}&w=460&output=webp&il`

        return {
          original: imageUrl,
          originalWidth: '380px',
          originalHeight: '380px',
        };
      });
      setImages(result);
    }
  }, [builderName, tour.images]);

    const isRental = useSelector((state: any) => state.builder.isRental);
    const price = new Intl.NumberFormat('en-US').format(tour.price)

  return (
    <div className="tour-card">
      {images.length > 0 ? (
        <ReactImageGallery
          items={images}
          showPlayButton={false}
          showFullscreenButton={false}
          additionalClass="image-gallery-custom"
          onErrorImageURL={imageIcon}
        />
      ) : (
        <img src={imagePlaceholder} alt="placeholder" style={{ padding: '0.5rem' }} />
      )}
      <div className="tour-card-body p-3">
        <h4 className="text-blue text-center">{tour.address_1}</h4>
        <div className="schedule-box">
          <div className="date-box img-text-box">
            <img src={calendar} alt="" />
            <p>{new Date(tour.scheduled_on).toLocaleDateString(displayLocale)}</p>
          </div>
          <div className="time-box img-text-box">
            <img src={clock} alt="" />
            <p>{new Date(tour.scheduled_on).toLocaleTimeString(displayLocale)}</p>
          </div>
        </div>
        {/* <h4 className='text-blue'>Lark</h4>
            <p className='text-blue mb-0'>AHome Site 4, From the Upper </p> */}
        <p className="my-2">${price}{isRental ? t('per_month'): ""}</p>
        <div className="room-details d-flex">
          <div className="time-box img-text-box">
            <img src={bed} alt="" />
            <p>{tour.bedrooms}{t('bedrooms_abbreviation')}</p>
          </div>
          <div className="time-box img-text-box">
            <img src={bath} alt="" />
            <p>{tour.fullBathrooms}{t('full_bathrooms_abbreviation')}</p>
          </div>
          <div className="time-box img-text-box">
            <img src={bath} alt="" />
            <p>{tour.halfBathrooms}{t('half_bathrooms_abbreviation')}</p>
          </div>
          <div className="time-box img-text-box">
            <img src={roomSize} alt="" />
            <p>{tour.squareFootage} {t('square_feet_abbreviation')}</p>
          </div>
        </div>
        <div className="img-text-box justify-content-start mt-2">
          <img src={location} alt="" />
          <p>
            {tour.address_1} {tour.city}, {tour.state} {tour.zipcode}
          </p>
        </div>
        {children}
      </div>
    </div>
  );
};

export default TourCard;
